import request from '../api/request'

function get(id) {
    return request({
        url: `/students/${id}.json`,
        method: 'GET'
    });
}

function update(clientId, data) {
    return request({
        url: `/students/${clientId}.json`,
        method: 'PUT',
        data: data
    });
}

function clientData(id) {
    return request({
        url: `/students/${id}/client_data.json`,
        method: 'GET',
    });
}

function create(data) {
    return request({
        url: `/students.json`,
        method: 'POST',
        data: data
    });
}

function createInClass(data) {
    return request({
        url: `/students/new_student_in_class.json`,
        method: 'POST',
        data: data
    });
}

function search(pattern, includeDeleted = false, activeOnly = false) {
    if (includeDeleted === true) {
        return request({
            url: `/students.json?with_chars=${pattern}&deleted=true&active=${activeOnly}`,
            method: 'GET'
        });
    } else {
        return request({
            url: `/students.json?with_chars=${pattern}&active=${activeOnly}`,
            method: 'GET'
        });
    }
}

function searchPartner(search) {
    return request({
        url: `/students/search_partner.json?search=${search}`,
        method: 'GET'
    });
}

function createReminder(data) {
    return request({
        url: `/reminders.json`,
        method: 'POST',
        data: data
    });
}

function deleteReminder(reminderId) {
    return request({
        url: `/reminders/${reminderId}.json`,
        method: 'DELETE',
    });
}

function getStudents(page, includeDeleted = false, activeOnly = false, filters = null, onlyNew = false, deletedOnly = false, sueltaOnly = false, blocked = false, startDate = null, endDate = null) {
    const groupFilters = filters && filters.groups ? filters.groups.map(it => it.id).toString() : ""
    const params = {
        page: page,
        web: true,
        active: activeOnly,
        groups: groupFilters,
        only_new: onlyNew,
        only_deleted: deletedOnly,
        only_suelta: sueltaOnly,
        blocked: blocked,
    }

    if (includeDeleted) {
        params["deleted"] = includeDeleted
    }

    if (startDate && endDate) {
        params["created_start"] = startDate
        params["created_end"] = endDate
    }

    return request({
        url: `students.json`,
        method: 'GET',
        params: params
    })
}

function searchStudents(searchValue) {
    return request({
            url: `students.json?with_chars=${searchValue}&short_form=true`,
            method: 'GET'
        }
    )
}

function deleteStudent(id) {
    return request({
            url: `students/${id}.json`,
            method: 'PUT',
            data: {
                is_archived: true
            }
        }
    )
}

function recoverClient(id) {
    return request({
            url: `students/recover_student.json?student_id=${id}`,
            method: 'POST'
        }
    )
}

function updateSM(data) {
    return request({
            url: `students/update_sm.json`,
            method: 'POST',
            data: data
        }
    )
}

function sendWelcome(id) {
    return request({
            url: `students/${id}/resend_welcome.json`,
            method: 'POST',
        }
    )
}

function exportData(activeOnly = false) {
    return request({
            url: `students/export_csv.json?only_active=${activeOnly}`,
            method: 'GET'
        }
    )
}

function exportTopFifty() {
    return request({
            url: `businesses/top_students_export.json`,
            method: 'POST'
        }
    )
}

function exportLoyalNoTicket() {
    return request({
            url: `businesses/loyal_nt_export.json`,
            method: 'POST'
        }
    )
}

function cancelMembership(studentId) {
    return request({
            url: `subscriptions/cancel_student_membership.json?student_id=${studentId}`,
            method: 'POST'
        }
    )
}

function mergeWithAnother(studentId, anotherStudentId) {
    return request({
            url: `students/merge_with_another.json?main_student_id=${studentId}&another_student_id=${anotherStudentId}`,
            method: 'POST'
        }
    )
}

function unblock(studentId) {
    return request({
            url: `students/${studentId}/unblock.json`,
            method: 'POST'
        }
    )
}

function loadDroppingStudents(page) {
    return request({
            url: `businesses/dropping_students.json`,
            method: 'GET',
            params: {days: 30, page: page}
        }
    )
}

function loadDroppingActive(page) {
    return request({
            url: `businesses/dropping_students.json`,
            method: 'GET',
            params: {active: true, page: page}
        }
    )
}

function loadTopFiftyStudents() {
    return request({
            url: `businesses/top_students.json`,
            method: 'GET',
        }
    )
}

function loadLoyalNoTicketStudents() {
    return request({
            url: `businesses/loyal_no_ticket.json`,
            method: 'GET',
        }
    )
}

function loadDroppingThisMonth(page) {
    return request({
            url: `businesses/dropping_this_month.json`,
            method: 'GET',
            params: {page: page}
        }
    )
}

function deletePhoto(student_id, user_id) {
    return request({
            url: `students/${student_id}/delete_photo.json`,
            method: 'POST',
            params: {all_instances: true, user_id: user_id}
        }
    )
}

const StudentApiService = {
    get,
    create,
    update,
    search,
    createReminder,
    clientData,
    deleteReminder,
    createInClass,
    getStudents,
    deleteStudent,
    recoverClient,
    searchPartner,
    exportData,
    exportTopFifty,
    exportLoyalNoTicket,
    updateSM,
    sendWelcome,
    cancelMembership,
    mergeWithAnother,
    unblock,
    loadDroppingStudents,
    loadDroppingThisMonth,
    loadDroppingActive,
    loadTopFiftyStudents,
    loadLoyalNoTicketStudents,
    deletePhoto
};

export default StudentApiService;